// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { ControlFilled, UsergroupAddOutlined, GroupOutlined, TeamOutlined } from '@ant-design/icons';
import useAuthContext from 'context/useAuthContext';

// type
import { NavItemType } from 'layout/mantis/types/MenuType';
import { TagFilled } from '@ant-design/icons/lib/icons';


// icons
const icons = {
    controlFilled: ControlFilled,
    usergroupAddOutlined: UsergroupAddOutlined,
    groupOutlined: GroupOutlined,
    teamOutlined: TeamOutlined,
    tagFilled: TagFilled,
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

export default function BatchMenuItems() {
    const { permissions, roles } = useAuthContext();
    let items: NavItemType = {};

    if (permissions) {

        if (permissions.some((el: string) => {
            // el === 'My_Batches' ||
            // || el === 'My_Groups'
            return (el === 'Manage_Batches' || el === 'Manage_Group')
        })) {
            items = {
                id: 'group-batch',
                title: 'Batch',
                type: 'group',
                icon: icons.teamOutlined,
                children: []
            };

            if (permissions.some((el: string) => {
                return (el === 'Manage_Batches')
            })) {
                items.children.push({
                    id: 'core-batch-list-batch',
                    title: 'Batches',
                    type: 'item',
                    url: '/app/batch/list/batches',
                    icon: icons.usergroupAddOutlined,
                    breadcrumbs: true
                });
            }
            if (permissions.some((el: string) => {
                return (el === 'My_Batches')
            })) {
                items.children.push({
                    id: 'core-batch-list-my-batches',
                    title: 'My Batches',
                    type: 'item',
                    url: '/app/batch/list/my/batches',
                    icon: icons.usergroupAddOutlined,
                    breadcrumbs: true
                });
            }

            // if (permissions.some((el: string) => {
            //     return (el === 'Manage_Group')
            // })) {
            //     items.children.push({
            //         id: 'core-group-list-group',
            //         title: 'Groups',
            //         type: 'item',
            //         url: '/app/group/list/groups',
            //         icon: icons.groupOutlined,
            //         breadcrumbs: true
            //     });
            // }
            // if (permissions.some((el: string) => {
            //     return (el === 'My_Groups')
            // })) {
            //     items.children.push({
            //         id: 'core-group-list-my-groups',
            //         title: 'My Groups',
            //         type: 'item',
            //         url: '/app/group/list/my/groups',
            //         icon: icons.groupOutlined,
            //         breadcrumbs: true
            //     });
            // }

            // if (permissions.some((el: string) => {
            //     return (el === 'Manage_Roles')
            // })) {
            //     items.children.push({
            //         id: 'core-hr-roles',
            //         title: 'Roles',
            //         type: 'item',
            //         url: '/app/hr/roles',
            //         icon: icons.controlFilled,
            //         breadcrumbs: false
            //     });
            // }
        }

    }

    return items;
}
